export default {
  login: () => import('./login/index.vue'), // 药品信息管理
  messageList: () => import('./message/index.vue'), // 消息列表
  messageDetail: () => import('./messageDetail/index.vue'), // 消息详情
  help: () => import('./help/index.vue'), // 帮助中心
  registe: () => import('./registe/index.vue'), // 申请注册
  forgetPwd: () => import('./forgetPwd/index.vue'), // 忘记密码
  updatePwd: () => import('./updatePwd/index.vue'), // 修改密码
};
